import React from "react";
import { bool, object, string } from "prop-types";

import LeftImageRightNews from "../../../molecules/LeftImageRightNews";
import { DfpComponent } from "../../../ads/dfp-component";
import DfpContainer from "../../../ads/dfp-container";
import ComponentContainer from "../../../layouts/component-container";

import { getSlotId } from "../../../utils/utils";

import "./singleCollection.m.css";

const SingleCollection = ({ collection, theme, adSlot, hideSubHeadline }) => {
  const { items = [], "associated-metadata": { layout } = {} } = collection;
  const stories = items.filter((item) => item.type === "story").slice(0, adSlot ? 3 : 5);

  if (!stories.length) {
    return null;
  }

  const [firstStory, ...restStory] = stories;

  return (
    <ComponentContainer
      styleName="base"
      className={theme || "default"}
      bannerClassNames={["single-collection-banner-photo", "single-collection-banner-photo-link"]}
      collection={collection}
      isDesktopBanner={true}
      isBanner={true}
      childContainer={true}
    >
      <div styleName="storyWrapper">
        <div styleName="first-item">
          <LeftImageRightNews
            story={firstStory.story}
            showSubHeading={!hideSubHeadline}
            showExcerpt={true}
            widths={[380, 480, 425]}
          />
        </div>
        <div styleName={`others ${adSlot ? "has-ads" : ""}`}>
          <div styleName="rest-items">
            {restStory.map(({ story }, index) => (
              <LeftImageRightNews
                key={index}
                story={story}
                showSubHeading={!hideSubHeadline}
                imageType="image1x1"
                aspectRatio={[1, 1]}
                widths={[140, 220, 180]}
              />
            ))}
          </div>
          {adSlot && (
            <DfpContainer styleName="dfp-ad">
              <DfpComponent
                type={adSlot}
                collectionSlug={collection.slug}
                slotId={getSlotId(adSlot, collection.slug, "single-collection")}
                layoutName={layout}
              />
            </DfpContainer>
          )}
        </div>
      </div>
    </ComponentContainer>
  );
};

SingleCollection.propTypes = {
  collection: object.isRequired,
  theme: string,
  adSlot: string,
  hideSubHeadline: bool,
};

export default SingleCollection;
